var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/chevronDown.d9c51a3d.png","uri@2x": __webpack_public_path__ + "static/media/chevronDown.ac740505.png","uri@3x": __webpack_public_path__ + "static/media/chevronDown.ac2ea169.png",
    width: 16,
    height: 16
});